import API from "../../../../../global/api";


export const requestAddMasterControl = () => {
    return {
        type: "REQUEST_ADD_MASTER_CONTROL",
    };
};
export const successAddMasterControl = (data) => {
    return {
        type: "SUCCESS_ADD_MASTER_CONTROL",
        payload: data,
    };
};
export const errorAddMasterControl = () => {
    return {
        type: "ERROR_ADD_MASTER_CONTROL",
    };
};
export const AddMasterControlApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddMasterControl());
        API.post(`/masterControl/add-master-control`, data).then((res) => {
            dispatch(successAddMasterControl(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddMasterControl());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestMasterControlData = () => {
    return {
        type: "REQUEST_MASTER_CONTROL_GET_DATA",
    };
};
export const successMasterControlGetData = (data) => {
    return {
        type: "SUCCESS_MASTER_CONTROL_GET_DATA",
        payload: data,
    };
};
export const errorMasterControlGetData = () => {
    return {
        type: "ERROR_MASTER_CONTROL_GET_DATA",
    };
};
export const GetMasterControlApi = () => {
    return (dispatch) => {
        dispatch(requestMasterControlData());
        API.get(`/masterControl/get-master-controls`).then((res) => {
            let getData = res.data;
            dispatch(successMasterControlGetData(getData));
        }).catch((error) => {
            dispatch(errorMasterControlGetData());
        })
    };
};